/* Generic Delete Confirmation Dialog
 *
 * Include by importing this module.  
 * 
 * Users of this dialog will provide:
 *  - The controller as "delConfirmDialog"
 *  - The display name of the object to be deleted 
 *    as a resolvable named "deleteTargetDisplayName"
 *
 *    Note additional angular module dependencies for consumers of this dialog
 *    - ngAnimate
 *    - ngSanitize
 *    - ui.bootstrap
 *
 */

import Assert from "tbAssert";

import ngSanitize from "angular-sanitize";
import ngAnimate from "angular-animate";
import uiBootstrapModule from "angular-ui-bootstrap";

import ConfirmDeleteDialogResult from "./ConfirmDeleteDialogResult";

const mModalInstanceSvc = new WeakMap();
const mDeleteTarget = new WeakMap();
const mGetDeleteTargetDisplayNameFn = new WeakMap();

const UserConfirmedDeleteStatusMessage = "DELETE_EVENT_USER_CONFIRMED";
const UserCancelledDeleteStatusMessage = "DELETE_EVENT_USER_CANCELLED";

class ConfirmDeleteDialogController {
    constructor($uibModalInstance, deleteTarget, deleteTargetDisplayNameGetter) {
        Assert.StrictAssert($uibModalInstance != null, "Assertion Failure: Missing UiB Modal Instance Dependency");
        Assert.StrictAssert(deleteTarget != null, "Assertion Failure: Missing/Invalid Deletion Target");

        mModalInstanceSvc.set(this, $uibModalInstance);
        mDeleteTarget.set(this, deleteTarget);

        if (deleteTargetDisplayNameGetter != null) {
            mGetDeleteTargetDisplayNameFn.set(this, deleteTargetDisplayNameGetter);
        }
        else {
            mGetDeleteTargetDisplayNameFn.set(this, function (tgt) { return tgt.toString(); });
        }
    }

    get targetName() {
        return mGetDeleteTargetDisplayNameFn.get(this)(mDeleteTarget.get(this));
    }

    confirmDelete() {
        mModalInstanceSvc.get(this).close(new ConfirmDeleteDialogResult({
            status: UserConfirmedDeleteStatusMessage,
            deleteTarget: mDeleteTarget.get(this)
        }));
    }

    cancelDialog() {
        mModalInstanceSvc.get(this).dismiss(UserCancelledDeleteStatusMessage);
    }
}

ConfirmDeleteDialogController.$inject = [
    "$uibModalInstance",
    "deleteTarget",
    "deleteTargetDisplayNameGetter"
];

ConfirmDeleteDialogController.dependencies = [
    ngAnimate,
    ngSanitize,
    uiBootstrapModule
];

ConfirmDeleteDialogController.template = require("./ConfirmDeleteDialog.tpl.html");

ConfirmDeleteDialogController.controllerAs = "delConfirmDialog";

ConfirmDeleteDialogController.UserConfirmedStatusMessage = UserConfirmedDeleteStatusMessage;
ConfirmDeleteDialogController.UserCancelledStatusMessage = UserCancelledDeleteStatusMessage;

export default ConfirmDeleteDialogController;



//////////////////
// WEBPACK FOOTER
// ./src/views/confirm-delete-dialog/ConfirmDeleteDialogController.js
// module id = BAiF
// module chunks = 1